import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

export default class ViewSelect extends Component {
  render() {
    return (
      <Row className="dev-view">
        <Col>View style</Col>
        <Col>
          {' '}
          <select
            onChange={e => {
              this.props.onChange();
            }}
          >
            <option value="human">human-friendly</option>
            <option value="dev">dev-friendly</option>
          </select>
        </Col>
      </Row>
    );
  }
}
